(function(){

    document.querySelector('.p-news-more').onclick = function(){

        let hide_lists = document.querySelectorAll('[data-visible=hide]');
        let count = 1;
        let start = performance.now();
        let duration = 250;

        for(let i=0; i < hide_lists.length; i++){
            //console.log(count);

            hide_lists[i].style.opacity = 0;

            if(count <= 3) requestAnimationFrame(function tick(timestamp) {
                let easing = (timestamp - start) / duration;

                hide_lists[i].style.opacity = Math.min(easing, 1);

                if (easing < 1) {
                    requestAnimationFrame(tick);
                } else {
                    hide_lists[i].style.opacity = '';
                }

                hide_lists[i].removeAttribute("data-visible");
            });

            count++;
        }

        if(hide_lists.length <= 3) document.querySelector('.p-news-more').style.display = "none";

        return false;
    };

}());
